const LOADING = 'common/LOADING';
const LOADED = 'common/LOADED';

export default {
  LOADING,
  LOADED,
}


// WEBPACK FOOTER //
// ./src/actions/commonTypes.js